export default [
    {
        'country': 'Toutes les villes',
        'country_ar': 'الكل',
    },
    {
    'country': 'Sfax',
    'country_ar': 'صفاقس',
  },{
    'country': 'Gabès',
    'country_ar': 'قابس',
  },{
    'country': 'Médenine',
    'country_ar': 'مدنين',
  },

];



// WEBPACK FOOTER //
// ./src/api/country.js